const KEY = 'quiz-app:pending-save';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function storePendingQuiz(quiz) {
  localStorage.setItem(KEY, JSON.stringify({ quiz, createdAt: Date.now() }));
}

export function getPendingQuiz() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const { quiz, createdAt } = JSON.parse(raw);
    if (Date.now() - createdAt <= MAX_AGE_MS && createdAt <= Date.now() &&
        typeof quiz.topic === 'string' && quiz.topic.trim() &&
        typeof quiz.category === 'string' && Array.isArray(quiz.questions) && quiz.questions.length) {
      return quiz;
    }
  } catch (_) {
    // A damaged draft should not break login.
  }
  localStorage.removeItem(KEY);
  return null;
}

export function clearPendingQuiz() {
  localStorage.removeItem(KEY);
}
